import firebase from 'firebase';


const firebaseConfig = {
    apiKey: "AIzaSyC4bB20uZwg7gMYTVRHZ7yiJNLvi2n3aFA",
    authDomain: "leo-techs-academy.firebaseapp.com",
    databaseURL: "https://leo-techs-academy.firebaseio.com",
    projectId: "leo-techs-academy",
    storageBucket: "leo-techs-academy.appspot.com",
    messagingSenderId: "121171623040",
    appId: "1:121171623040:web:772b728ff03a826cad3a65",
    measurementId: "G-M2KE31J95S"
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth;
export const db = firebase.firestore();